export default __webpack_public_path__ + "static/media/rack-wall.ce312a77.png";